"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TOOLBAR_BUTTONS = void 0;

var _react = _interopRequireWildcard(require("react"));

var _joditReact = _interopRequireDefault(require("jodit-react"));

var _jodit = require("jodit");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useCustomColorPicker = _interopRequireDefault(require("./useCustomColorPicker"));

var _useCustomFonts = _interopRequireWildcard(require("./useCustomFonts"));

var _useDynamicFields = _interopRequireWildcard(require("./useDynamicFields"));

var _OverrideStyles = _interopRequireDefault(require("./OverrideStyles"));

var _html = require("./html");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Only gets triggered on paste in text area, not in the source code mode
var _processPaste = function processPaste(html) {
  var onError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  var clean = (0, _html.sanitize)(html);

  if (!(0, _html.isValid)(html)) {
    onError();
  }

  return clean;
};

var EDITOR_LANGUAGES = {
  pt_br: 'pt',
  fr_CA: 'fr',
  de: 'de',
  es: 'es'
};
var TOOLBAR_BUTTONS = {
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  ALIGN: 'align',
  UL: 'ul',
  OL: 'ol',
  LINK: 'link',
  UNLINK: 'unlink',
  IMAGE: 'image',
  ERASER: 'eraser',
  SOURCE: 'source',
  COLOR: 'brush',
  FONT: 'font',
  FONTSIZE: 'fontsize',
  CUSTOM_FONTS: _useCustomFonts.TOOLBAR_BUTTON_CUSTOM_FONTS
};
exports.TOOLBAR_BUTTONS = TOOLBAR_BUTTONS;
var DARK_MODE_THEME = 'dark';
var LIGHT_MODE_THEME = 'default';
var DEFAULT_TOOLBAR_BUTTONS = [TOOLBAR_BUTTONS.CUSTOM_FONTS, TOOLBAR_BUTTONS.FONTSIZE, TOOLBAR_BUTTONS.BOLD, TOOLBAR_BUTTONS.ITALIC, TOOLBAR_BUTTONS.UNDERLINE, TOOLBAR_BUTTONS.COLOR, TOOLBAR_BUTTONS.ALIGN, TOOLBAR_BUTTONS.UL, TOOLBAR_BUTTONS.OL, TOOLBAR_BUTTONS.LINK, TOOLBAR_BUTTONS.UNLINK, TOOLBAR_BUTTONS.IMAGE, TOOLBAR_BUTTONS.SOURCE, TOOLBAR_BUTTONS.ERASER];
var defaultConfig = {
  readonly: false,
  showPlaceholder: true,
  height: 'inherit',
  buttons: DEFAULT_TOOLBAR_BUTTONS,
  toolbarAdaptive: false,
  toolbarSticky: false,
  allowResizeX: false,
  allowResizeY: false,
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  beautifyHTML: false,
  processPasteHTML: false,
  showMessageErrors: true,
  useSplitMode: false,
  link: {
    noFollowCheckbox: false,
    modeClassName: false,
    openInNewTabCheckbox: false
  },
  enter: 'p',
  colorPickerDefaultTab: 'color',
  disablePlugins: 'wraptextnodes',
  image: {
    editClass: false,
    editStyle: false,
    editSize: false,
    selectImageAfterClose: true,
    openOnDblClick: false
  },
  events: {
    processPaste: (e, text) => _processPaste(text)
  },
  popup: {
    img: [..._jodit.Jodit.defaultOptions.popup.img.filter(option => option.name !== 'pencil' && option.name !== 'left'), 'align', 'link', 'unlink'],
    a: _jodit.Jodit.atom(_jodit.Jodit.defaultOptions.popup.a.filter(option => option !== 'brush' && option !== 'file'))
  },
  allowResizeTags: [..._jodit.Jodit.defaultOptions.allowResizeTags, 'dynamic-field' // currently this is the best way to "highlight" dynamic field on Firefox and Safari
  ]
};

var Editor = (_ref) => {
  var {
    value: initialHTML = '',
    onChange,
    showColor = true,
    colorPickerLocale = {
      button: "Custom",
      title: "Select custom color"
    },
    buttons = [...DEFAULT_TOOLBAR_BUTTONS],
    readOnly,
    onPasteError,
    id = null,
    isDarkMode = false,
    moreFontsLabel = 'More Fonts',
    language = 'en',
    customFonts = [],
    onAddFonts = () => {},
    dynamicFieldsOpts = {}
  } = _ref;
  // Need the memo here as when rendered inside Ant field
  // config gets changed on rerender due to buttons and onPasteError
  // After the initial render is done, only isDarkMode is expected to change
  // so only adding isDarkMode to memo deps
  var conf = (0, _react.useMemo)(() => {
    var _EDITOR_LANGUAGES$lan;

    return _objectSpread(_objectSpread({}, defaultConfig), {}, {
      readOnly,
      buttons: [...(showColor ? buttons : buttons.filter(button => button !== TOOLBAR_BUTTONS.COLOR)), ...(0, _useDynamicFields.getToolbarButtons)(dynamicFieldsOpts)],
      language: (_EDITOR_LANGUAGES$lan = EDITOR_LANGUAGES[language]) !== null && _EDITOR_LANGUAGES$lan !== void 0 ? _EDITOR_LANGUAGES$lan : 'en',
      theme: isDarkMode ? DARK_MODE_THEME : LIGHT_MODE_THEME
    }, onPasteError && {
      events: {
        processPaste: (e, text) => _processPaste(text, onPasteError)
      }
    });
  }, [isDarkMode, showColor]);
  (0, _useCustomColorPicker.default)(colorPickerLocale, showColor);
  var dynamicFieldControls = (0, _useDynamicFields.default)(dynamicFieldsOpts);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_OverrideStyles.default, null), /*#__PURE__*/_react.default.createElement(JoditWrapper, {
    onContentChange: onChange,
    initialHTML: initialHTML,
    config: conf,
    id: id,
    customFonts: customFonts,
    moreFontsLabel: moreFontsLabel,
    onAddFonts: onAddFonts
  }), dynamicFieldControls);
};

var JoditWrapper = (_ref2) => {
  var {
    onContentChange,
    initialHTML,
    config,
    id,
    customFonts,
    moreFontsLabel,
    onAddFonts
  } = _ref2;
  var RTE = (0, _react.useRef)(null);
  var conf = (0, _useCustomFonts.default)(config, initialHTML, customFonts, moreFontsLabel, onAddFonts);
  /**
   * We need to use both onBlur and onChange because:
   * 1. onChange is required to stop the behavior where changes are not getting reflected sometimes
   * 2. onBlur is required because in Angular pages, you cannot completely delete the contents
   *    so "" will never get saved, that is because state variable content is always empty inside the
   *    update functions for angular pages, tried using useCallback but no use
   */

  var handleChange = newContent => {
    var processed = (0, _html.ensureValidLinks)(newContent);
    onContentChange(processed);
  };

  var handleBlur = event => {
    if (event === null || event === void 0 ? void 0 : event.target) {
      handleChange(event.target.innerHTML || '');
    }
  };

  return /*#__PURE__*/_react.default.createElement(_joditReact.default, {
    id: id,
    ref: RTE,
    value: initialHTML,
    config: conf,
    onChange: handleChange,
    onBlur: handleBlur
  });
};

JoditWrapper.propTypes = {
  initialHTML: _propTypes.default.string,
  onContentChange: _propTypes.default.func,
  config: _propTypes.default.shape({}),
  id: _propTypes.default.string,
  customFonts: _propTypes.default.arrayOf(_propTypes.default.string),
  moreFontsLabel: _propTypes.default.string,
  onAddFonts: _propTypes.default.func
};
Editor.propTypes = {
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  showColor: _propTypes.default.bool,
  colorPickerLocale: _propTypes.default.shape({
    button: _propTypes.default.string,
    title: _propTypes.default.string
  }),
  language: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  onPasteError: _propTypes.default.func,
  id: _propTypes.default.string,
  isDarkMode: _propTypes.default.bool,
  customFonts: _propTypes.default.arrayOf(_propTypes.default.string),
  moreFontsLabel: _propTypes.default.string,
  onAddFonts: _propTypes.default.func,
  dynamicFieldsOpts: _propTypes.default.shape({
    fields: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      label: _propTypes.default.string.isRequired,
      isExtra: _propTypes.default.bool
    })),
    extraLocale: _propTypes.default.string.isRequired
  }),
  // Order matters for buttons
  buttons: _propTypes.default.arrayOf(_propTypes.default.oneOf([TOOLBAR_BUTTONS.BOLD, TOOLBAR_BUTTONS.ITALIC, TOOLBAR_BUTTONS.UNDERLINE, TOOLBAR_BUTTONS.ALIGN, TOOLBAR_BUTTONS.UL, TOOLBAR_BUTTONS.OL, TOOLBAR_BUTTONS.LINK, TOOLBAR_BUTTONS.UNLINK, TOOLBAR_BUTTONS.IMAGE, TOOLBAR_BUTTONS.ERASER, TOOLBAR_BUTTONS.SOURCE, TOOLBAR_BUTTONS.COLOR, TOOLBAR_BUTTONS.FONTSIZE, TOOLBAR_BUTTONS.FONT, TOOLBAR_BUTTONS.CUSTOM_FONTS]))
};
var _default = Editor;
exports.default = _default;